import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=62f52a20&scoped=true"
import script from "./Custom.vue?vue&type=script&lang=js"
export * from "./Custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f52a20",
  null
  
)

export default component.exports